export enum LoginFlowType {
    CREDENTIALS = 'creds',
    OAUTH_DIRECT = 'oAuth_direct',
    OAUTH_AFTER_LOGIN = 'oAuth_after_login',
    DIRECT_AFTER_LOGIN = 'direct_after_login'
}

export enum VendorType {
    GUEST = 'guest',
    BROKER = 'broker'
}

export enum ManageBrokersTab {
    AVAILABLE = 0,
    CONNECTED = 1
}